function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.8114 10.6982C14.8644 9.80111 13.2546 10.16 12.8758 11.3262C12.5917 12.1337 11.6448 12.5822 10.7925 12.4028C8.89856 11.9542 6.34175 9.62168 5.86826 7.73771C5.58417 6.93027 6.15235 6.03314 7.00462 5.76404C8.23568 5.40519 8.61447 3.88007 7.6675 2.98295L5.01599 0.470991C4.25842 -0.156997 3.12206 -0.156997 2.45918 0.470991L0.659948 2.17553C-1.13929 3.96978 0.849341 8.72455 5.30009 12.941C9.75083 17.1575 14.7698 19.1313 16.6637 17.337L18.4629 15.6324C19.1258 14.9147 19.1258 13.8382 18.4629 13.2102L15.8114 10.6982Z",
  id: "Vector",
  fill: "#FFD300",
  fillRule: "evenodd",
  stroke: "none"
})));

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.fa4dfe02.svg";
export { ForwardRef as ReactComponent };